import React, { Suspense } from 'react';
import { pick, prop } from 'ramda';

import { BackboneReplacer } from '@core/js/backbone/components/BackboneReplacer';
import { Button } from '@core/js/components/common/Button';
import { Link } from '@core/js/components/common/Link';
import { Logo } from '@core/js/components/main/DefaultHeader/components/Logo';
import { LogoutButton } from '@core/js/components/main/LogoutButton';

import { MyAccount } from '@theme/js/components/main/DefaultHeader/components/MyAccount/MyAccount';
import { MyBalance } from '@theme/js/components/main/DefaultHeader/components/MyBalance/MyBalance';
import { DefaultMenu } from '@theme/js/components/main/DefaultMenu/DefaultMenu';

import * as hooks from '@core/js/components/main/DefaultHeader/hooks';
import { useComponentTranslations } from '@core/js/hooks/component';
import { useAppSelector, useUserSelector } from '@core/js/store/hooks';

import { AUTOMATED_TEST_IDS } from '@interlayer/js/custom/constants';
import { useDynamicTags } from '@interlayer/js/custom/hooks/useDynamicTags';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/custom/utils/constants';
import { clsx } from '@interlayer/js/utils/classNames.util';

import style from './DesktopHeader.scss';

export const DesktopHeader: React.FC = () => {
    const translate = useComponentTranslations();
    const onLoginButtonClick = hooks.useOnLoginButtonClick();
    const { registrationURL } = useAppSelector(pick(['registrationURL']));
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const [
        dTagForgottenPassword = '/forgotten_password',
        dTagBonusCodeHeaderURL = '/promocode'
    ] = useDynamicTags([DYNAMIC_TAG_NAMES.FORGOTTEN_PASSWORD, DYNAMIC_TAG_NAMES.BONUS_CODE_HEADER_URL]);

    return (
        <div className={style.header}>
            <div className={style.info}>
                <Logo />
            </div>

            <div className={style.menu}>
                <DefaultMenu slideMenuWcId={null} />
            </div>

            <div className={style.controls}>
                {isLoggedIn
                    ? (
                        <div className={style.container}>
                            <MyAccount />
                            <div className={style.navigation}>
                                <Button
                                    className={style.bonusCodeBtn}
                                    href={dTagBonusCodeHeaderURL}
                                    color="negative"
                                >
                                    {translate('bonusCodeBtn')}
                                </Button>

                                <div className={style.deposit}>
                                    <BackboneReplacer dynamicName="HEADER_DEPOSIT_BUTTON" viewName="headerdepositbutton"/>
                                </div>

                                <MyBalance/>

                                <Suspense fallback="">
                                    <LogoutButton className={style.logout}/>
                                </Suspense>
                            </div>
                        </div>
                    )
                    : (
                        <div className={style.wrap}>
                            <div className={style.buttons}>
                                {registrationURL && (
                                    <Button
                                        color="negative"
                                        href={registrationURL}
                                        className={style.register}
                                    >
                                        {translate('login.button.join_now')}
                                    </Button>
                                )}

                                <Button
                                    color="success"
                                    className={clsx(style.login, AUTOMATED_TEST_IDS.login)}
                                    onClick={onLoginButtonClick}
                                >
                                    {translate('login.button.loginHeader')}
                                </Button>
                            </div>

                            <Link className={style.forgottenPassword} href={dTagForgottenPassword}>
                                {translate('forgot.password.head.link')}
                            </Link>
                        </div>
                    )
                }
            </div>
        </div>
    );
};
